import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import AffichageEquipeInfo from './affichageInfoEquipe';
import NavCoach from '../navigation/navCoach';

function EquipeInfoCoach() {
    const Navigate = useNavigate();
    const [userData, setUserData] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [type,setType] = useState(null)
    const apiUrl = process.env.REACT_APP_API_URL;


    

  
  
    useEffect(() => {
      setIsLoading(true);
      const fetchData = async () => {
        try {
          const response = await axios.post(
            `${apiUrl}/verification/cookie`,
            {},
            {
              withCredentials: true // Permet de transmettre les cookies avec la requête
            }
          );
          setUserData(response.data);
          setError(null);
          setIsLoading(false);
          setType(response.data.user.type)

          if (response.data.user.type !== "coach") {
            Navigate('/connexion');
          }
  
        } catch (error) {
          if (error.response) {
            
            setError(error.response.data.message);
          } else {
         
            setError(true)
          }
          Navigate('/connexion')
          setIsLoading(false);
  
        }
      };
  
      fetchData(); 
    }, [Navigate, apiUrl]);

  
          if (isLoading) {
            return (
            <div className="centered-content">
              <img src="/img/logo.png" alt="Logo" className="centered-logo" />
              <br/>
              <span className="loader"></span>
            </div>
            
            );  
          }





          return (
            <>   
                  {error && 
                  <>
                    <div id="alert-message" className="alert4" >
                        <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
                    </div>
                  </>  
                    }
                  {userData ? (
                  <> 
                      <NavCoach userData={userData} nom='Equipe'/>
                      <AffichageEquipeInfo userData={userData} type={type}/>
                    </>
                          ) :(
                            <>       
                          <div id="alert-message" className="alert" >
                              <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
                          </div></>
                          )}
                  </>
                          
                  );
            
            
            }


export default EquipeInfoCoach;
